import JSURL from 'jsurl';
import { useMemo } from 'react';

const ONE_MINUTE = 60 * 1000;
const PERIOD = 30;

const owner = {
  id: '68744962',
  name: 'Zenfi',
};

const getRandom = (from, to) => Math.round((to - from) * Math.random() - from);

const getTimeToReview = () => getRandom(ONE_MINUTE, 120 * ONE_MINUTE);

const getReviews = () => getRandom(5, 40);

const getComments = (reviews) => getRandom(0, 5 * reviews);

const buildReviewer = ({ id, name }) => {
  const reviews = getReviews();
  return {
    i: id,
    n: name,
    r: reviews,
    t: getTimeToReview(),
    c: getComments(reviews),
  };
};

const reviewers = [
  buildReviewer({ id: '8755542', name: 'jartmez' }),
  buildReviewer({ id: '1031639', name: 'manuelmhtr' }),
  buildReviewer({ id: '33379285', name: 'ernestognw' }),
  buildReviewer({ id: '2009676', name: 'javierbyte' }),
  buildReviewer({ id: '8495952', name: 'Phaze1D' }),
];

const buildSampleUrl = () => JSURL.stringify({
  u: {
    i: owner.id,
    n: owner.name,
  },
  p: PERIOD,
  r: reviewers,
});

export const useSampleUrl = () => useMemo(() => buildSampleUrl(), []);
